import React, { useMemo } from "react"
import acceptingNewPatients from "./assets/acceptingNewPatients.svg"
import additionIcon from "./assets/addition.svg"
import additionWithCircle from "./assets/additionWithCircle.svg"
import addUser from "./assets/addUser.svg"
import alert from "./assets/alert.svg"
import arrowLeft from "./assets/arrowLeft.svg"
import calendar from "./assets/calendar.svg"
import camera from "./assets/camera.svg"
import checkCircle from "./assets/circleCheck.svg"
import chevronDown from "./assets/chevronDown.svg"
import chevronDownWhite from "./assets/chevronDownWhite.svg"
import chevronLeft from "./assets/chevronLeft.svg"
import chevronRight from "./assets/chevronRight.svg"
import chevronRightDouble from "./assets/chevronRightDouble.svg"
import chevronUp from "./assets/chevronUp.svg"
import chevronUpBlue from "./assets/chevronUpBlue.svg"
import circleOne from "./assets/circleOne.svg"
import circleOneBlue from "./assets/circleOneBlue.svg"
import circleThree from "./assets/circleThree.svg"
import circleThreeBlue from "./assets/circleThreeBlue.svg"
import circleTwo from "./assets/circleTwo.svg"
import circleTwoBlue from "./assets/circleTwoBlue.svg"
import circleX from "./assets/circleX.svg"
import closeoutX from "./assets/closeoutX.svg"
import closeoutXBlue from "./assets/closeoutXBlue.svg"
import closeoutXOrange from "./assets/closeoutXOrange.svg"
import closeoutXRed from "./assets/closeoutXRed.svg"
import completedIcon from "./assets/completed.svg"
import copy from "./assets/copy.svg"
import whiteCopy from "./assets/whiteCopy.svg"
import datepickerLeftArrow from "./assets/arrow-left.svg"
import datepickerRightArrow from "./assets/arrow-right.svg"
import docusign from "./assets/docusign.png"
import dotsVertical from "./assets/dotsVertical.svg"
import edit from "./assets/edit.svg"
import editGray from "./assets/editGray.svg"
import errorIcon from "./assets/exclamationError.svg"
import exclamation from "./assets/exclamation.svg"
import exportFile from "./assets/exportFile.svg"
import facebook from "./assets/facebook.svg"
import fastMoney from "./assets/fastMoney.svg"
import file from "./assets/file.svg"
import fileDownload from "./assets/fileDownload.svg"
import fileImage from "./assets/fileImage.svg"
import fileZip from "./assets/fileZip.svg"
import filterFunnel from "./assets/filterFunnel.svg"
import garbageCan from "./assets/garbageCan.svg"
import greenBulb from "./assets/bulbGreen.svg"
import hamburger from "./assets/hamburger.png"
import helpIcon from "./assets/Group 3887.svg"
import hide from "./assets/hide.png"
import homeIcon from "./assets/thriving at home.svg"
import houseIcon from "./assets/house.svg"
import incompleteIcon from "./assets/incomplete.svg"
import infoIcon from "./assets/exclamationInfo.svg"
import infoQuestionmark from "./assets/infoQuestionmark.svg"
import infoQuestionmarkLightGray from "./assets/infoQuestionmarkLightGray.svg"
import linkedin from "./assets/linkedin.svg"
import locationMarker from "./assets/locationMarker.svg"
import mailbox from "./assets/mailbox.svg"
import mapPin from "./assets/mapPin.svg"
import mapPins from "./assets/mapPins.svg"
import payments from "./assets/payments.svg"
import pendingIcon from "./assets/pending.svg"
import piggyBank from "./assets/piggyBank.svg"
import practiceIndividuals from "./assets/practiceIndividuals.svg"
import practiceProfile from "./assets/practiceProfile.svg"
import profileCard from "./assets/profileCard.svg"
import providerProfile from "./assets/providerProfile.svg"
import questionPurple from "./assets/questionPurple.svg"
import readyIcon from "./assets/ready.svg"
import redBulb from "./assets/bulbRed.svg"
import referrals from "./assets/referrals.svg"
import remove from "./assets/trash.svg"
import removeLightGray from "./assets/trashLightGray.svg"
import saved from "./assets/saved.svg"
import search from "./assets/search.svg"
import selectedBullet from "./assets/selectedBullet.svg"
import show from "./assets/show.png"
import subtractionWithCircle from "./assets/subtractionWithCircle.svg"
import successCheckmark from "./assets/successCheckmark.svg"
import taskboardSearch from "./assets/taskboardSearch.svg"
import scrollingKnurling from "./assets/scrollingKnurling.svg"
import thumbUp from "./assets/thumbUp.svg"
import userAccount from "./assets/userAccount.svg"
import twitter from "./assets/twitter.svg"
import unselectedBullet from "./assets/unselectedBullet.svg"
import warning from "./assets/warning.svg"
import warningIcon from "./assets/exclamationWarning.svg"
import blueCheckmark from "./assets/blueCheckmark.svg"
import greenCheckmark from "./assets/greenCheckmark.svg"
import whiteCheckmark from "./assets/whiteCheckmark.svg"
import yellowBulb from "./assets/bulbYellow.svg"

import { cva } from "class-variance-authority"
import cn from "../../../../utils/classes"

export type Status = "completed" | "incomplete" | "ready" | "waiting"
export type BulbColors = "greenBulb" | "yellowBulb" | "redBulb"
export type Navigation =
  | "selectedBullet"
  | "unselectedBullet"
  | "arrowLeft"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronRightDouble"
  | "chevronUp"
  | "chevronUpBlue"
  | "chevronDownWhite"
export type Controls =
  | "addition"
  | "additionWithCircle"
  | "subtractionWithCircle"
  | "x"
  | "xRed"
  | "xBlue"
  | "xOrange"
  | "hide"
  | "show"
  | "garbageCan"
  | "copy"
  | "whiteCopy"
  | "filterFunnel"
export type Misc =
  | "addUser"
  | "homeIcon"
  | "houseIcon"
  | "helpIcon"
  | "mailbox"
  | "hamburger"
  | "pending"
  | "error"
  | "info"
  | "warningIcon"
  | "infoQuestionmark"
  | "infoQuestionmarkLightGray"
  | "exclamation"
  | "warning"
  | "camera"
  | "checkCircle"
  | "successCheckmark"
  | "circleX"
  | "check"
  | "edit"
  | "editGray"
  | "locationMarker"
  | "remove"
  | "removeLightGray"
  | "docusign"
  | "piggyBank"
  | "profileCard"
  | "mapPin"
  | "mapPins"
  | "calendar"
  | "saved"
  | "search"
  | "alert"
  | "dotsVertical"
  | "acceptingNewPatients"
  | "payments"
  | "referrals"
  | "practiceIndividuals"
  | "practiceProfile"
  | "providerProfile"
  | "taskboardSearch"
  | "scrollingKnurling"
  | "thumbUp"
  | "blueCheckmark"
  | "greenCheckmark"
  | "whiteCheckmark"
  | "fastMoney"
  | "questionPurple"
  | "userAccount"
export type FileTypes =
  | "file"
  | "fileImage"
  | "fileZip"
  | "fileDownload"
  | "exportFile"
export type Numbers =
  | "circleOne"
  | "circleTwo"
  | "circleThree"
  | "circleOneBlue"
  | "circleTwoBlue"
  | "circleThreeBlue"
export type Social = "facebook" | "twitter" | "linkedin"
export type Datepicker = "datepickerLeftArrow" | "datepickerRightArrow"
export type IconType =
  | Status
  | Misc
  | Navigation
  | BulbColors
  | Controls
  | FileTypes
  | Numbers
  | Social
  | Datepicker
export type Size = "sm" | "md" | "ml" | "lg" | "xl" | "2xl"
export const iconStyleType = { TABLE: "table-icon", DEFAULT: "" } as const

export type IconStyleKey = keyof typeof iconStyleType
export type IconStyleType = (typeof iconStyleType)[IconStyleKey]

export interface IconProps {
  disabled?: boolean
  iconType: IconType
  size?: Size
  altText?: string
  dataId?: string
  styleOverrides?: string
  iconStyle?: IconStyleKey
  id?: string
}

/**
 * `Icon` is a customizable icon component that supports various types of icons including status, navigation, controls, file types, numbers, social, and more.
 *
 * @component
 * @example
 * / Example usage of Icon
 * <Icon iconType="homeIcon" size="lg" altText="Home Icon" />
 *
 * @param {object} props - The properties that define the Icon component.
 * @param {boolean} [props.disabled] - If true, the icon will be disabled.
 * @param {IconType} props.iconType - The type of the icon. This can be one of various types including status, navigation, controls, file types, numbers, social, and more.
 * @param {Size} [props.size] - The size of the icon. This can be "sm", "md", "ml", "lg", "xl", or "2xl".
 * @param {string} [props.altText=iconType + " icon"] - The alt text for the icon. This is used for accessibility and defaults to the icon type plus "icon".
 * @param {string} [props.dataId] - The data-id attribute for the icon. This can be used for testing or other data tracking purposes.
 * @param {string} [props.styleOverrides] - Override styles for the icon. This can be any valid CSS as a string.
 *
 * @returns {React.Component} The Icon component.
 */
const Icon: React.FC<IconProps> = ({
  disabled,
  iconType,
  size,
  altText = iconType + " icon",
  dataId,
  styleOverrides,
  iconStyle = iconStyleType.DEFAULT,
  id,
}) => {
  const iconTypeMap: Record<string, string> = {
    addUser: addUser,
    completed: completedIcon,
    incomplete: incompleteIcon,
    ready: readyIcon,
    waiting: readyIcon,
    addition: additionIcon,
    homeIcon: homeIcon,
    houseIcon: houseIcon,
    helpIcon: helpIcon,
    mailbox: mailbox,
    hamburger: hamburger,
    pending: pendingIcon,
    error: errorIcon,
    info: infoIcon,
    warningIcon: warningIcon,
    infoQuestionmark: infoQuestionmark,
    infoQuestionmarkLightGray: infoQuestionmarkLightGray,
    hide: hide,
    show: show,
    selectedBullet: selectedBullet,
    unselectedBullet: unselectedBullet,
    checkCircle: checkCircle,
    circleX: circleX,
    arrowLeft: arrowLeft,
    greenBulb: greenBulb,
    yellowBulb: yellowBulb,
    redBulb: redBulb,
    chevronDown: chevronDown,
    chevronLeft: chevronLeft,
    chevronRight: chevronRight,
    chevronRightDouble: chevronRightDouble,
    chevronUp: chevronUp,
    chevronUpBlue: chevronUpBlue,
    chevronDownWhite: chevronDownWhite,
    x: closeoutX,
    xRed: closeoutXRed,
    xBlue: closeoutXBlue,
    xOrange: closeoutXOrange,
    additionWithCircle: additionWithCircle,
    subtractionWithCircle: subtractionWithCircle,
    file: file,
    fileDownload: fileDownload,
    exportFile: exportFile,
    fileImage: fileImage,
    fileZip: fileZip,
    camera: camera,
    circleOne: circleOne,
    circleTwo: circleTwo,
    circleThree: circleThree,
    circleOneBlue: circleOneBlue,
    circleTwoBlue: circleTwoBlue,
    circleThreeBlue: circleThreeBlue,
    edit: edit,
    editGray: editGray,
    locationMarker: locationMarker,
    remove: remove,
    removeLightGray: removeLightGray,
    garbageCan: garbageCan,
    filterFunnel: filterFunnel,
    docusign: docusign,
    piggyBank: piggyBank,
    profileCard: profileCard,
    mapPin: mapPin,
    mapPins: mapPins,
    facebook: facebook,
    twitter: twitter,
    linkedin: linkedin,
    calendar: calendar,
    warning: warning,
    saved: saved,
    search: search,
    copy: copy,
    whiteCopy: whiteCopy,
    alert: alert,
    successCheckmark: successCheckmark,
    exclamation: exclamation,
    datepickerLeftArrow: datepickerLeftArrow,
    datepickerRightArrow: datepickerRightArrow,
    dotsVertical: dotsVertical,
    acceptingNewPatients: acceptingNewPatients,
    referrals: referrals,
    payments: payments,
    practiceIndividuals: practiceIndividuals,
    practiceProfile: practiceProfile,
    providerProfile: providerProfile,
    taskboardSearch: taskboardSearch,
    scrollingKnurling: scrollingKnurling,
    thumbUp: thumbUp,
    blueCheckmark: blueCheckmark,
    greenCheckmark: greenCheckmark,
    whiteCheckmark: whiteCheckmark,
    fastMoney: fastMoney,
    questionPurple: questionPurple,
    userAccount: userAccount,
  }

  const variants = cva(["bg-transparent", iconStyle], {
    variants: {
      size: {
        sm: " w-3 h-3",
        md: " w-5 h-5",
        ml: " w-8 h-8",
        lg: " w-10 h-10",
        xl: " w-12 h-12",
        "2xl": " w-14 h-14",
      },
      iconType: { waiting: "opacity-30" },
      disabled: { true: "cursor-not-allowed opacity-50" },
    },
  })

  const className = useMemo(() => {
    const _iconType = iconType === "waiting" ? iconType : null
    return cn(variants({ disabled, iconType: _iconType, size }), styleOverrides)
  }, [size, iconType, styleOverrides, disabled, variants])

  const icon = iconTypeMap[iconType]

  return (
    <img
      data-id={dataId}
      className={`${className}`}
      src={icon}
      alt={altText}
      id={id}
    />
  )
}

export default Icon
